module.exports = __webpack_public_path__ + "media/entities/1128-cc5f9027.png";